import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "refetch"];
import { registerQuery, useQuery } from 'data-fetching-client';
import { useRefetchOnWindowFocus } from '../utils/useRefetchOnWindowFocus';
import { api } from '../utils/api';
import { LOGIN_VERIFY_PATH } from '../../api/paths';
const GET_LOGIN_VERIFY = 'getLoginVerify';
const getLoginVerify = async () => {
  const response = await api(LOGIN_VERIFY_PATH);
  return response.json();
};
const GET_LOGIN_VERIFY_QUERY = registerQuery({
  fieldName: GET_LOGIN_VERIFY,
  fetcher: getLoginVerify
});
export const useLoginVerify = () => {
  const _useQuery = useQuery(GET_LOGIN_VERIFY_QUERY),
    {
      data,
      loading,
      refetch
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  useRefetchOnWindowFocus({
    refetch,
    loading
  });
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data[GET_LOGIN_VERIFY],
    refetch,
    loading
  }, rest);
};